import { QIcon_chevron_right } from '@repo/icons/index'
import classNames from 'classnames'
import { useEffect, useMemo, useState } from 'react'
import {
  CREDITS_AVAILABILITY_ID,
  CREDITS_CATEGORY_ID,
  CREDITS_LENGTH_ID,
  CouponType,
  ICouponBundles,
} from '../../../model/credit.interface'
import { useCouponBundlesList, useWeeklyLessonProgress } from '../../../modules/apis/student/credit'
import { APP_SCREEN_NAME } from '../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useIsWebview from '../../../modules/hooks/common/useIsWebview'
import useReturnFullUrl from '../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_common, n_credit, s_credit } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'
import WeeklyLessonProgressPopup from '../../modal/WeeklyLessonProgressPopup'
import WeeklyLessonProgressStatus from '../../student/new-portal/WeeklyLessonProgressStatus'

const SectionCredit = () => {
  const isWebview = useIsWebview()
  const router = useAppRouter()
  const getFullUrl = useReturnFullUrl()
  const { t, isLocaleKO } = useTranslation()
  const [showProgressModalPopup, setShowProgressModalPopup] = useState(false)
  const [popupData, setPopupData] = useState(null)
  const [couponBundle, setCouponBundle] = useState(null)
  const [weeklyLessonPackages, setWeeklyLessonPackages] = useState([])
  const [filterList, setFilterList] = useState([
    { value: CREDITS_AVAILABILITY_ID.USABLE },
    { value: CREDITS_CATEGORY_ID.REGULAR },
    { value: CREDITS_LENGTH_ID.IS_20_MIN },
    { value: CREDITS_LENGTH_ID.IS_40_MIN },
  ])
  const { data, isLoading } = useCouponBundlesList({
    selectedFilters: filterList,
  })

  const { data: weeklyLessonProgress } = useWeeklyLessonProgress({
    bundleId: couponBundle?.is_weekly_lesson_package && couponBundle?.started ? couponBundle?.id : null,
  })

  const dataList: ICouponBundles[] = useMemo(
    () =>
      data && data.pages
        ? data.pages
            .map((page) => page.coupon_bundles)
            .flat()
            .filter((bundles) => bundles.type == CouponType.CouponBundle)
        : [],
    [data]
  )

  useEffect(() => {
    const couponBundles = dataList.sort((a, b) => {
      if (a.started !== b.started) {
        return b.started ? 1 : -1
      }
      return b.is_weekly_lesson_package ? 1 : -1
    })

    setWeeklyLessonPackages(dataList.filter((bundle) => bundle.is_weekly_lesson_package && bundle.started))
    setCouponBundle(couponBundles[0])
  }, [data])

  const handleWeeklyModal = async (e) => {
    e.preventDefault()
    router.push(urls.student.newPortal.mypage.weeklyLessonPackage(couponBundle?.id), {
      appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
      appSendData: {
        url: getFullUrl(urls.webview.mypage.weeklyLessonPackage(couponBundle?.id)),
      },
    })
  }

  if (!data || isLoading) return <></>
  if (!couponBundle) return <></>

  return (
    <>
      {weeklyLessonProgress && weeklyLessonProgress.weeks?.length > 0 && (
        <WeeklyLessonProgressStatus
          data={weeklyLessonProgress}
          setCouponBundle={setCouponBundle}
          handleWeeklyModal={handleWeeklyModal}
          couponBundle={couponBundle}
          weeklyLessonPackages={weeklyLessonPackages}
        />
      )}
      <div
        onClick={(e) =>
          router.push(urls.student.newPortal.mypage.currentCredit(0), {
            appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
            appSendData: {
              url: getFullUrl(urls.webview.mypage.currentCredit(0)),
            },
          })
        }
      >
        <div className={classNames('rounded-[8px] border-[1px] border-gray-200 p-[16px]')}>
          <div className="flex flex-col items-start">
            <div className="flex flex-row items-start gap-x-[4px]">
              <div className="Caption-12Bd flex rounded-[4px] bg-gray-100 py-[2px] px-[6px] text-gray-600">
                {couponBundle.lesson_duration == 40 ? t(n_common.label_40min) : t(n_common.label_20min)}
              </div>
              {couponBundle.is_weekly_lesson_package && (
                <div className="Caption-12Bd rounded-[4px] bg-red-50 px-[6px] pt-[2px] text-red-500">
                  {t(n_common.label_weekly)}
                </div>
              )}
            </div>
            <div className="mt-[8px] flex items-center">
              <div className="Title2-18Bd mr-[4px]">{isLocaleKO ? couponBundle.name : couponBundle.name_eng}</div>
              <QIcon_chevron_right />
            </div>
          </div>
          <div className="my-[12px] h-[1px] w-full bg-gray-200"></div>
          <div className="flex items-center justify-between py-[8px] px-[4px] text-gray-700">
            <div className="Body2-14Md">{t(s_credit.status_2)}</div>
            <div className="flex items-center">
              <div>{t(n_credit.count(couponBundle.remain_credit_counts))}</div>
            </div>
          </div>
          <div className="flex items-center justify-between py-[8px] px-[4px] text-gray-700">
            <div className="Body2-14Md">{t(n_credit.desc2)}</div>
            <div className="flex items-center">
              <div>{t(n_credit.count2(couponBundle?.exp_dates[0]))}</div>
            </div>
          </div>
        </div>
      </div>

      {popupData && (
        <WeeklyLessonProgressPopup
          data={popupData}
          showPopup={showProgressModalPopup}
          setShowPopup={setShowProgressModalPopup}
        />
      )}
    </>
  )
}
export default SectionCredit
